import { mapState, mapGetters, mapActions } from 'vuex'

export const appAuthComputed = {
  ...mapState('appAuth', {
    appSession: (state) => state.appSession,
  }),
  ...mapGetters('appAuth', ['appLoggedIn', 'updateCompanyInfo']),
}

export const appAuthMethods = mapActions(
  'appAuth', ['appLogIn', 'companyInfoExists'])


export const authComputed = {
  ...mapState('auth', {
    currentSession: (state) => state.currentSession,
  }),
  ...mapGetters('auth', ['loggedIn']),
}

export const authMethods = mapActions(
  'auth', ['logIn', 'logOut', 'register', 'resetPasswordAction',
  'resetPassword', 'setUserActiveSection', 'forgotPasswordAction'])


export const languageComputed = {
  ...mapState('language', {
    language: (state) => state.language,
  })
}

export const languageMethods = mapActions(
  'language', ['setLanguage'])

export const usersComputed = {
  ...mapState('users', {
    cached: (state) => state.cached,
  }),
}

export const usersMethods = mapActions(
  'users', [
  'fetchUsers', 'createUpdateUsers',
  'deleteUsers', 'changePassword',
  'updatePhotos', 'fetchUsersDetail',
  'fetchUsersForOptions', 'checkIfUserExists',
  'registerUsers', 'fetchUserOptions']
)

export const permsComputed = {
  ...mapState('perms', {
    cached: (state) => state.cached,
  }),
}

export const permsMethods = mapActions(
  'perms', ['fetchPerms', 'createUpdatePerms',
  'deletePerms', 'fetchPermsDetail'])


export const groupsComputed = {
  ...mapState('groups', {
    cached: (state) => state.cached,
  }),
}

export const groupsMethods = mapActions(
  'groups', ['fetchGroups', 'createUpdateGroups',
  'deleteGroups', 'fetchGroupsDetail'])

export const appSectionsComputed = {
  ...mapState('appSections', {
    cached: (state) => state.cached,
  }),
}

export const appSectionsMethods = mapActions(
  'appSections', ['fetchAppSections', 'createUpdateAppSections',
  'deleteAppSections', 'fetchAppSectionsDetail'])



export const companyInfoComputed = {
  ...mapState('companyInfo', {
    cached: (state) => state.cached,
  }),
}

export const companyInfoMethods = mapActions(
  'companyInfo', ['fetchCompanyInfo', 'createUpdateCompanyInfo', 'setFileCompanyInfo'])

export const smartCarMethods = mapActions(
  'smartCar', ['fetchCardholders', 'manualCreateEuroSmartCarCardholders', 'manualDeleteEuroSmartCarCardholders', 'fetchCardholderDetail'])

export const timeSoftMethods = mapActions(
  'timeSoft', ['manualCreateTimeSoft',])

// Periodic tasks helpers
export const periodicTasksMethods = mapActions(
  'periodicTasks', ['fetchPeriodicTasks', 'createUpdatePeriodicTasks',
  'deletePeriodicTasks', 'fetchPeriodicTasksDetail', 'fetchPeriodicTasksOptions',
  'getLiveResultsPeriodicTasks', 'executeManuallyPeriodicTasks'])

export const periodicTasksResultsMethods = mapActions(
  'periodicTasksResults', ['fetchPeriodicTasksResults', 'createUpdatePeriodicTasksResults',
  'deletePeriodicTasksResults', 'fetchPeriodicTasksResultsDetail'])

export const periodicTasksSolarScheduleMethods = mapActions(
  'periodicTasksSolarSchedule', ['fetchPeriodicTasksSolarSchedule', 'createUpdatePeriodicTasksSolarSchedule',
  'deletePeriodicTasksSolarSchedule', 'fetchPeriodicTasksSolarScheduleDetail'])

export const periodicTasksIntervalScheduleMethods = mapActions(
  'periodicTasksIntervalSchedule', ['fetchPeriodicTasksIntervalSchedule', 'createUpdatePeriodicTasksIntervalSchedule',
  'deletePeriodicTasksIntervalSchedule', 'fetchPeriodicTasksIntervalScheduleDetail'])

export const periodicTasksClockedScheduleMethods = mapActions(
  'periodicTasksClockedSchedule', ['fetchPeriodicTasksClockedSchedule', 'createUpdatePeriodicTasksClockedSchedule',
  'deletePeriodicTasksClockedSchedule', 'fetchPeriodicTasksClockedScheduleDetail'])

export const periodicTasksCrontabScheduleMethods = mapActions(
  'periodicTasksCrontabSchedule', ['fetchPeriodicTasksCrontabSchedule', 'createUpdatePeriodicTasksCrontabSchedule',
  'deletePeriodicTasksCrontabSchedule', 'fetchPeriodicTasksCrontabScheduleDetail'])

export const habeasMethods = mapActions('habeasData', ['fetchMessageHabeas',
  'createBulkHabeasAction', 'sendHabeasDataSurvey'])

export const captacionMethods = mapActions('captacionPos',
  ['fetchCashRegisterList', 'setStore', 'setStores',
    'setCashRegister', 'setCasherRegister'])

export const paylessMethods = mapActions('payless',
  ['paylessOrderDetail', 'paylessAuthorizeOrder', 'fetchLogsPayless', 'fetchPaylessReport'])

// EuroPayless Issue helpers
export const euroPaylessIssueMethods = mapActions(
  'euroPaylessIssue', ['fetchEuroPaylessIssue', 'fetchEuroPaylessIssueOptions',
  'fetchEuroPaylessIssueDetail', 'fetchReportManagementExcelPayless'])
export const euroPaylessLogsMethods = mapActions(
  'euroPaylessLogs', ['fetchEuroPaylessLogs', 'fetchEuroPaylessLogsOptions',
  'fetchEuroPaylessLogsDetail'])

export const euroInventoryMethods = mapActions('euroInventory', ['fetchProducts', 'fetchProductsExcel', 'processExcelData', 'manualCreateProductsHomologated'])

// START - EURO COUPONS

// EuroCoupons Coupon helpers
export const euroCouponsCouponMethods = mapActions(
  'euroCouponsCoupon', ['fetchEuroCouponsCoupon', 'createUpdateEuroCouponsCoupon', 'setCxcEuroCouponsCoupon', 'approveInactiveEuroCouponsCoupon',
  'deleteEuroCouponsCoupon', 'fetchEuroCouponsCouponDetail', 'fetchEuroCouponsCouponOptions',
  'checkEuroCouponsCoupon', 'fetchDownloadCouponsReport', 'fetchEuroCouponsCouponRedeemed',
  'fetchRedeemedReport', 'RedeemEuroCouponsCoupon'])


// EuroCoupons RequestCoupon helpers
export const euroCouponsRequestCouponMethods = mapActions(
  'euroCouponsRequestCoupon', ['fetchEuroCouponsRequestCoupon', 'createUpdateEuroCouponsRequestCoupon',
  'deleteEuroCouponsRequestCoupon', 'fetchEuroCouponsRequestCouponDetail', 'fetchEuroCouponsRequestCouponOptions',
  'manualCreateEuroCouponsRequestCoupon', 'fetchDownloadReport', 'sendGeneralReportRequestCoupon',
  'getReportEuroCouponsRequestCoupon', 'sendReportEuroCouponsRequestCoupon', 'manualDeleteInternalEuroCouponsRequestCoupon', 'manualDeleteEuroCouponsRequestCoupon', 'manualCreateInternalEuroCouponsRequestCoupon'])


// EuroCoupons Thirdparty helpers
export const euroCouponsThirdpartyMethods = mapActions(
  'euroCouponsThirdparty', ['fetchEuroCouponsThirdparty', 'createUpdateEuroCouponsThirdparty',
  'fetchEuroCouponsThirdpartyDetail', 'fetchEuroCouponsThirdpartyOptions',
  'deleteEuroCouponsThirdparty',
  'fetchEuroCouponsCashRegisterThirdpartyOptions'])


// EuroCoupons Issue helpers
export const euroCouponsIssueMethods = mapActions(
  'euroCouponsIssue', ['fetchEuroCouponsIssue', 'createUpdateEuroCouponsIssue',
  'deleteEuroCouponsIssue', 'fetchEuroCouponsIssueDetail', 'fetchEuroCouponsIssueOptions'])

export const euroCouponsItemMethods = mapActions(
  'euroCouponsItem', ['fetchEuroCouponsItem', 'createUpdateEuroCouponsItem',
  'deleteEuroCouponsItem', 'fetchEuroCouponsItemDetail', 'fetchEuroCouponsItemOptions'])


// EuroCoupons Tutorials
export const euroCouponsTutorialMethods = mapActions(
  'euroCouponsTutorials',
  ['setTutorialUrl', 'setShowTutorial']
)

export const euroCouponsTypesMethods = mapActions(
  'euroCouponsTypes',
  ['fetchEuroCouponsTypes', 'fetchEuroCouponsTypesOptions', 'createUpdateEuroCouponsTypes', 'deleteEuroCouponsTypes']
)

export const euroHabeasDataReportsManagement = mapActions(
  'reports/management',
  ['fetchReportManagement', 'fetchReportManagementExcel', 'fetchCashOptions', 'fetchCoOptions', 'fetchCashRegisterOptions']
)

export const invoiceControlManagement = mapActions(
  'invoiceControl',
  ['fetchInvoiceEuroSmart',
    'fetchInvoiceEuroSmartCart', 'patchInvoiceEuroSmart', 'patchInvoiceEuroSmartCart']
)

// END  - EURO COUPONS